<div *ngIf="itProfiles && itProfiles.length == 0">
  No IT Profile has been associated with this project yet
</div>
<div *ngIf="itProfiles && itProfiles.length > 0">
  <div style="display: flex; flex-direction: row;" *ngIf="itProfiles.length > 1" style="justify-content: center; align-items: center; margin-top: 10px">
    <mat-form-field>
      <mat-label>Select Profile</mat-label>
    <mat-select  [(value)]="itProfile" style="width: 200px;">
      <mat-option *ngFor="let profile of itProfiles" style="display: block; cursor: pointer;"
                  [value]="profile">{{profile.name || 'Unnamed'}}</mat-option>
    </mat-select>
    </mat-form-field>


  </div>
  <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 10px">
    <button mat-raised-button (click)="generate()">Ok</button>
    <button mat-raised-button (click)="onClose()">Cancel</button>
  </div>
</div>
